export default class AppConfigClient {
  adminEmail = "info@namedicinu.cz";

  constructor() {}
}
